import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from ".";
import { Ingest } from "../../models";
import { IngestService } from "../../services/ingest-service";

export type IngestState = {
    ingestMetaData: Ingest[];
  };
  
  export const initialState: IngestState = {
    ingestMetaData: [],
  };

  const ingestSlice = createSlice({
    name: 'fuelIngest',
    initialState,
    reducers: {
     saveIngest: (state, action: any) => {

     }
    },
    extraReducers: {},
  });
  
  export const { saveIngest } = ingestSlice.actions;
  
  // export ingestSlice selector to get the slice in any component
  export const ingestSelector = (state: RootState) => state.ingest;
  // export The reducer
  const ingestReducer = ingestSlice.reducer;
  export default ingestReducer;
  

  export const startIngest = createAsyncThunk(
    'fuelIngest/startIngest',
    async (ingests:Ingest[] , { dispatch }) => {
      for (let i = 0; i < ingests.length; i++) {
        if (ingests[i].title) {
            ingests[i].title = ingests[i].title.trim();
        }
        if (ingests[i].automatedTitle) {
            ingests[i].automatedTitle = ingests[i].automatedTitle.trim();
        }
      }
      return new Promise((resolve, reject) => {
        IngestService.createIngest(ingests)
          .then(function(result) {
            resolve(result);
          })
          .catch(function(e) {
            throw new Error(e);
          });
      });
    }
  );